import React, { memo } from 'react';
import { useAppSelector } from 'store/hooks';
import { selectIsInvestWalkthroughActive } from 'reducers/selectors/walkthrough';
import { InvestWalkthroughContext } from './context';
import InvestWalkthroughContent from './InvestWalkthroughContent';
const InvestWalkthrough = ({ isInTab, scrollRef, scrollHeight, itemPositions, isFixedPosition, scrollLayoutHeight, }) => {
    const isInvestWalkthroughActive = useAppSelector(selectIsInvestWalkthroughActive);
    if (!isInvestWalkthroughActive) {
        return null;
    }
    return (<InvestWalkthroughContext.Provider value>
      <InvestWalkthroughContent scrollRef={scrollRef} isInTab={isInTab} scrollHeight={scrollHeight} itemPositions={itemPositions} isFixedPosition={isFixedPosition} scrollLayoutHeight={scrollLayoutHeight}/>
    </InvestWalkthroughContext.Provider>);
};
export default memo(InvestWalkthrough);
